import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation"]

  sync() {
    this.confirmationTarget.value = this.passwordTarget.value
  }
}
